import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { AppConfigService } from '@core/appconfig.service';
import { BrowserService } from '@core/browser.service';
import { BehaviorSubject, skipWhile, Subscription } from 'rxjs';
import { LoginPageRolesByRoute } from '../../shared/enums/login-page-type';

/**
 * Branded layout wrapper for the login form.
 *
 * Will either show the login form (default) or QR code when student clicks the "Login with QR code" button
 */
@Component({
  selector: 'zbp-branded-login',
  templateUrl: './branded-login.component.html',
  styleUrls: ['./branded-login.component.scss'],
  standalone: false
})
export class BrandedLoginComponent implements OnInit, OnDestroy {
  isHighlights: boolean = false;
  brandClass: string = null;
  logoSrc: string = null;
  logoAlt: string = null;
  isLoading: boolean = false;
  isQrScannerRunning$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private subscriptions: Subscription[] = [];

  constructor(
    private appConfig: AppConfigService,
    public browserService: BrowserService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(
      this.route.data.pipe(
        skipWhile((params: Params) => !params),
      ).subscribe((params: Params) => {
        this.isHighlights = this.appConfig.isHighlightsPortalUrl;
        if (this.isHighlights) {
          this.setupHighlightsPortalData();
        } else if (params.formMode === LoginPageRolesByRoute.Student) {
          this.setupZbPortalStudentData();
        } else {
          this.setupZbPortalData();
        }

        this.isLoading = false;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions?.forEach(sub => sub.unsubscribe());
  }

  /**
   * Used to setup data for HL Portal view. All items specific to HL Portal should be done here.
   */
  private setupHighlightsPortalData() {
    this.brandClass = 'hl-portal-login';
    this.logoSrc = 'assets/img/highlights-logo.svg';
    this.logoAlt = 'Highlights Portal logo return to Overview';
  }

  /**
   * Used to setup data for ZB Portal view. All items specific to ZB Portal should be done here.
   */
  private setupZbPortalData() {
    this.brandClass = 'zb-portal-login';
    this.logoSrc = 'assets/zbportal/img/zb-logo.svg';
    this.logoAlt = 'ZB Portal logo return to Overview';
  }

  private setupZbPortalStudentData() {
    this.brandClass = 'zb-portal-login zb-portal-student-login';
    this.logoSrc = 'assets/zbportal/img/zb-logo.svg';
    this.logoAlt = 'ZB Portal logo return to Overview';
  }
}
